import { api } from '@/api/ApiGateway.js'

class OrganizationRequestsApi
{
	create(userId, name, address, city, state, zip, type, dateOpened, npi, onSuccess, onError)
	{
		api.post('organization-requests/organization-requests', {
			'organization_request': {
				'requestor_user_id': userId,
				'name': name,
				'address': address,
				'city': city,
				'state': state,
				'zip_code': zip,
				'organization_type': type,
				'date_opened': dateOpened,
				'npi': npi
			}
		}).then(response =>
		{
			if (response.hasError())
			{
				onError(response)
				return
			}
			if (!response.body()?.data)
			{
				response.overrideError({ detail: 'Error creating organization.' })
				onError(response)
				return
			}

			onSuccess(response.body()?.data)
		})
	}

	getForUser(userId, onSuccess, onError)
	{
		api.get(`organization-requests/organization-requests/user/${userId}`).then(response =>
		{
			if (response.hasError())
			{
				onError(response)
				return
			}
			if (!response.body()?.data)
			{
				response.overrideError({ detail: 'Error loading organization data.' })
				onError(response)
				return
			}

			onSuccess(response.body()?.data)
		})
	}
}

export const organizationRequestsApi = new OrganizationRequestsApi()